import type { RouteRecordRaw } from 'vue-router'

import { AuthLayout as Layout } from '@/apps/adok/app/layout'

const RestorePasswordPage = () =>
  import('@/apps/adok/pages/restore-password').then(
    (m) => m.RestorePasswordPage
  )

const ResetPasswordPage = () =>
  import('@/apps/adok/pages/reset-password').then((m) => m.ResetPasswordPage)

const ConfirmationPage = () =>
  import('@/apps/adok/pages/confirmation').then((m) => m.ConfirmationPage)

const RegistrationPage = () =>
  import('@/apps/adok/pages/registration').then((m) => m.RegistrationPage)

const LoginPage = () =>
  import('@/apps/adok/pages/login').then((m) => m.LoginPage)

const authRoutes: RouteRecordRaw[] = [
  {
    // `/login/:token` is the confirmation letter's link — the guard in `app/router.ts`
    // rewrites a `?confirmation_token=` landing into it, and the screen answers it on
    // mount. One route with an optional segment rather than two, so both spellings reach
    // the same page and only one name exists to push to.
    path: '/login/:token?',
    component: Layout,
    children: [
      {
        path: '',
        name: 'login',
        component: LoginPage,
        meta: {
          hidden: true,
          title: 'Login',
          auth: true
        }
      }
    ]
  },
  {
    path: '/restore',
    component: Layout,
    children: [
      {
        path: '',
        name: 'restore',
        component: RestorePasswordPage,
        meta: {
          hidden: true,
          title: 'Restore password',
          auth: true
        }
      }
    ]
  },
  {
    path: '/registration',
    component: Layout,
    children: [
      {
        path: '',
        name: 'registration',
        component: RegistrationPage,
        meta: {
          hidden: true,
          title: 'Registration',
          auth: true
        }
      }
    ]
  },
  {
    path: '/confirmation',
    component: Layout,
    children: [
      {
        path: '',
        name: 'confirmation',
        component: ConfirmationPage,
        meta: {
          hidden: true,
          title: 'Confirmation',
          auth: true
        }
      }
    ]
  },
  {
    // `reset_password`, not `reset-password`: the guard in `app/router.ts` turns a
    // `?reset_password_token=` landing into `/#/reset_password/<token>` as a string, and
    // the letters the backend has already sent point at that path.
    path: '/reset_password/:token',
    component: Layout,
    children: [
      {
        path: '',
        name: 'reset_password',
        component: ResetPasswordPage,
        meta: {
          hidden: true,
          title: 'Reset password',
          auth: true
        }
      }
    ]
  }
]

export default authRoutes
